import React, { memo } from 'react';
import PropTypes from 'prop-types';

import createStyle from 'shared-utils/src/createStyle';
import makeClassName from 'shared-utils/src/makeClassName';
import isString from 'shared-utils/src/checkVarType/isString';

import Grid from '../Grid';

import styles, { mainCls } from './styles';

const useStyles = createStyle(styles);

const um = (x) => {
	return x[x.length - 1] === '%' || (x === 'auto') || (isString(x) && x.indexOf('calc') === 0)
		? x
		: `${x}px`;
}

function SkeletonBox({
	mt,
	mr,
	mb,
	ml,
	width,
	height,
	boxed,
	className,
	direction,
	justify,
	align,
	children,
	hideOnMobile,
	brColor,
}) {
	const cls = useStyles();
	const cName = makeClassName([
		cls[mainCls],
		className,
		boxed && cls[`${mainCls}--boxed`],
		hideOnMobile && cls[`${mainCls}--nomobile`],
	])
	const propsStyle = {
		marginTop: mt && um(mt),
		marginRight: mr && um(mr),
		marginBottom: mb && um(mb),
		marginLeft: ml && um(ml),
		width: width && um(width),
		height: height && um(height),
		borderColor: brColor && `${brColor}!important`,		
	};
	return (
		<Grid direction={direction} justify={justify} align={align} className={cName} style={propsStyle}>
			{children}
		</Grid>
	);
};
SkeletonBox.propTypes = {
	mt: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	mr: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	mb: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	ml: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	width: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	height: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	boxed: PropTypes.bool,
	className: PropTypes.string,
	direction: PropTypes.string,
	justify: PropTypes.string,
	align: PropTypes.string,
	children: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.object,
		PropTypes.string,
		PropTypes.node,
	]),
	hideOnMobile: PropTypes.bool,
	brColor: PropTypes.string,
};
SkeletonBox.defaultProps = {
	mt: null,
	mr: null,
	mb: null,
	ml: null,
	width: '100%',
	height: null,
	boxed: false,
	className: null,
	direction: null,
	justify: null,
	align: null,
	children: null,
	hideOnMobile: false,
	brColor: null,
};
export default memo(SkeletonBox);